<template>
  <div class="body">
    <div>
      <div class="editTitle">基本信息</div>
      <table class="table" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableLabel">对账类型:</td>
          <td class="tableModel">{{reconcileOrderVO.billType === 10 ? "整单对账" : "拆单对账"}}</td>
          <td class="tableLabel">对账单号：</td>
          <td class="tableModel">{{reconcileOrderVO.billNo}}</td>
          <td class="tableLabel">对账日期：</td>
          <td class="tableModel">{{reconcileOrderVO.createTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">供应商编号：</td>
          <td class="tableModel">{{reconcileOrderVO.supplierNo}}</td>
          <td class="tableLabel">供应商名称：</td>
          <td class="tableModel">{{reconcileOrderVO.supplierName}}</td>
          <td class="tableLabel">公司：</td>
          <td class="tableModel">S100电气</td>
        </tr>
        <tr>
          <td class="tableLabel">货币：</td>
          <td class="tableModel">CNY 中国人民币(CNY)</td>
          <td class="tableLabel">税率：</td>
          <td class="tableModel">{{reconcileOrderVO.taxNumber}}</td>
          <td class="tableLabel">采购组：</td>
          <td class="tableModel">{{reconcileOrderVO.buyUserName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">创建人：</td>
          <td class="tableModel">{{reconcileOrderVO.creatorName}}</td>
          <td class="tableLabel">备注:</td>
          <td class="tableModel" colspan="3">{{reconcileOrderVO.note}}</td>
        </tr>
      </table>
      <div style="background: #fff1f0;color: red;border: 1px solid #ff0000;font-size: 12px;font-weight: bold;padding-left: 5px">
        <p>注意：</p>
        <p>1：开票金额以调整差异金额为准！！</p>
        <p>2：财务开具发票时，余额必须为0！！</p>
        <p>3：差额可以不为0。如果差额过大，请关注行项差异大的金额！！</p>
        <p>4：如果申请开票后修改了采购订单金额，请及时退回对账单重新选择采购单对账！！</p>
        <p>5：只有采购订单行项全部入库后才可以申请对账！！</p>
        <p>6：明细不含税金额=sum(调整差异金额)； 结算不含税金额=sum(计算不含税金额)； 差额=结算不含税金额-明细不含税金额； 余额=实际开票不含税金额-明细不含税金额</p>
      </div>
      <div class="editTitle">金额信息</div>
      <table class="table1" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableLabel1">明细不含税金额</td>
          <td class="tableModel1">{{taxNotIncluded.toFixed(2)}}</td>
          <!--          <td class="tableLabel1">明细税额</td>-->
          <!--          <td class="tableModel1">{{taxSum.toFixed(2)}}</td>-->
          <!--          <td class="tableLabel1">明细含税</td>-->
          <!--          <td class="tableModel1">{{(taxNotIncluded+taxSum).toFixed(2)}}</td>-->
          <td class="tableLabel1">结算不含税金额</td>
          <td class="tableModel1">{{taxNotIncludedJS.toFixed(2)}}</td>
          <td class="tableLabel1">差额</td>
          <td class="tableModel1" colspan="3">{{(taxNotIncludedJS.toFixed(2)-taxNotIncluded.toFixed(2)).toFixed(2)}}</td>
        </tr>
        <tr>
          <td class="tableLabel1">实际开票不含税金额</td>
          <td class="tableModel1">
            <el-input
                v-show="nodeId === 'VendorApprove'"
                v-model="reconcileOrderVO.invoice.netAmount"
                placeholder="请输入实际开票不含税金额(保留两位小数)"/>
            <span
                v-show="nodeId !== 'VendorApprove'">{{reconcileOrderVO.invoice.netAmount ? parseFloat(reconcileOrderVO.invoice.netAmount).toFixed(2) : ""}}</span>
          </td>
          <td class="tableLabel1">实际开票税额</td>
          <td class="tableModel1">
            <el-input
                v-show="nodeId === 'VendorApprove'"
                v-model="reconcileOrderVO.invoice.taxAmount"
                placeholder="请输入实际开票税额(保留两位小数)"/>
            <span
                v-show="nodeId !== 'VendorApprove'">{{reconcileOrderVO.invoice.taxAmount ? parseFloat(reconcileOrderVO.invoice.taxAmount).toFixed(2) : ""}}</span>
          </td>
          <td class="tableLabel1">实际开票含税金额</td>
          <td class="tableModel1">
            <el-input
                v-show="nodeId === 'VendorApprove'"
                v-model="reconcileOrderVO.invoice.amount"
                placeholder="请输入实际开票含税金额(保留两位小数)"/>
            <span
                v-show="nodeId !== 'VendorApprove'">{{reconcileOrderVO.invoice.amount ? parseFloat(reconcileOrderVO.invoice.amount).toFixed(2) : ""}}</span>
          </td>
          <td class="tableLabel1">余额</td>
          <td class="tableModel1">
            <!--            {{reconcileOrderVO.invoice.amount ? (reconcileOrderVO.invoice.netAmount).toFixed(2)-taxNotIncluded.toFixed(2) : ""}}-->
            {{reconcileOrderVO.invoice.amount ? (taxNotIncluded.toFixed(2)-reconcileOrderVO.invoice.netAmount).toFixed(2) : ""}}
          </td>
        </tr>
        <tr>
          <td class="tableLabel1">发票日期</td>
          <td class="tableModel1">
            <el-date-picker
                v-show="nodeId === 'VendorApprove'"
                v-model="reconcileOrderVO.invoice.invoiceDate"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                style="width: 100%"
                placeholder="请输入发票日期"/>
            <span
                v-show="nodeId !== 'VendorApprove'">{{reconcileOrderVO.invoice.invoiceDate ? reconcileOrderVO.invoice.invoiceDate.slice(0, 10) : ""}}</span>
          </td>
          <td class="tableLabel1">发票号码</td>
          <td class="tableModel1" colspan="7">
            <el-input
                v-show="nodeId === 'VendorApprove'"
                v-model.trim="reconcileOrderVO.invoice.invoiceNo"
                placeholder="请输入发票号码"/>
            <span v-show="nodeId !== 'VendorApprove'">{{reconcileOrderVO.invoice.invoiceNo}}</span>
          </td>
        </tr>
        <tr>
          <td class="tableLabel1">发票凭证的凭证号码</td>
          <td class="tableModel1">{{reconcileOrderVO.invoice.FBELNR}}</td>
          <td class="tableLabel1">发票凭证年度</td>
          <td class="tableModel1">{{reconcileOrderVO.invoice.GJAHR}}</td>
          <td class="tableLabel1">财务凭证</td>
          <td class="tableModel1" colspan="3">{{reconcileOrderVO.invoice.KBELNR}}</td>
        </tr>
      </table>
      <div class="editTitle" style="display: flex;flex-direction: row;align-items: center">
        <div>对账明细</div>
        <div style="margin-left: 20px">
          <el-checkbox v-model="priceFlags" @change="priceFlagType"/>
          <span style="font-size: 13px; font-weight: 600; margin-left: 3px">暂估</span>
        </div>
        <div>
          <el-button style="font-size: 13px; margin-left: 3px" type="primary" @click="downloadDetail(reconcileOrderVO)">
            明细下载
          </el-button>
        </div>
        <div class="historyBtn" style="color: #2d8cf0; font-size: 12px; margin-left: 1%; cursor: pointer" @click="changeOptionalPriceVOS()">
          {{isShow ? "隐藏" : "展开"}}
          <el-button style="padding: 1px 2px" :icon="isShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"/>
        </div>
      </div>
      <el-table
          v-if="isShow"
          stripe
          border
          class="reconcileTable"
          :data="priceFlagTypeList">
        <el-table-column label="采购单信息" align="center" style="">
          <el-table-column prop="poCreateTime" align="center" width="85" label="下单日期">
            <template slot-scope="scope">
              <span>{{scope.row.poCreateTime ? scope.row.poCreateTime.slice(0, 10) : ""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="priceFlag" align="center" width="70" label="价格类型"/>
          <el-table-column prop="partNo" width="85" align="center" label="物料编号"/>
          <el-table-column prop="partNameSpec" min-width="160" show-overflow-tooltip label="物料名称"/>
          <el-table-column width="130" align="center" label="采购订单/行号">
            <template slot-scope="scope">
              <div>{{scope.row.evaluate + "/" + scope.row.poDetailRowNo}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="poQuantity" align="center" width="95" label="采购订单数量"/>
          <el-table-column prop="poStockedQuantity" align="center" width="85" label="已收数量"/>
          <el-table-column prop="poQuantity" align="center" width="85" label="未收数量">
            <template slot-scope="scope">
              <span>{{scope.row.poStockedQuantity ? (scope.row.poQuantity - scope.row.poStockedQuantity) : ""}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="送货单信息" align="center">
          <el-table-column width="130" align="center" label="送货单号/行号">
            <template slot-scope="scope">
              <div>{{scope.row.asnNo + "/" + scope.row.asnRowIndex}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="sumQuantity" align="center" width="90" label="送货单数量"/>
          <el-table-column prop="instockQuantity" align="center" width="80" label="入库数量"/>
        </el-table-column>
        <el-table-column label="对账单信息" align="center">
          <el-table-column prop="quantity" align="center" width="100" label="本次对账数量">
            <template slot-scope="scope">
              <el-input
                  v-if="nodeId === 'Purchase1stApprove'"
                  v-model="scope.row.quantity"
                  class="inputCenter"
                  placeholder="请输入"/>
              <span v-else>{{scope.row.quantity}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="netPrice" align="center" width="100" label="不含税单价">
            <template slot-scope="scope">
              <el-input
                  v-if="nodeId === 'Purchase1stApprove'"
                  v-model="scope.row.netPrice"
                  class="inputCenter"
                  placeholder="请输入"
                  :disabled="scope.row.priceFlag !== '暂估'"/>
              <span v-else>{{scope.row.netPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" label="结算含税单价">
            <template slot-scope="scope">
              <span>{{(scope.row.netPrice * (parseInt(reconcileOrderVO.taxNumber.split("%"))/100+1)).toFixed(6)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="150" label="调整差异金额(不含税)">
            <template slot-scope="scope">
              <span
                  v-show="parseFloat(scope.row.finalPrice) !== parseFloat((scope.row.quantity * scope.row.netPrice).toFixed(2))"
                  style="color:red">*</span>
              <el-input
                  v-if="nodeId === 'Purchase1stApprove' || nodeId === 'Purchase2ndApprove' || nodeId ==='VendorApprove'"
                  v-model="scope.row.finalPrice"
                  class="inputCenter"
                  style="width: 80px;"
                  placeholder="请输入"/>
              <span v-else>{{scope.row.finalPrice.toFixed(6)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="110" label="结算不含税金额">
            <template slot-scope="scope">
              <span>{{(scope.row.quantity * scope.row.netPrice).toFixed(6)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100" label="结算含税金额">
            <template slot-scope="scope">
              <span>{{(scope.row.quantity * (scope.row.netPrice *(parseInt(reconcileOrderVO.taxNumber.split("%"))/100+1))).toFixed(6)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unit" align="center" width="80" label="单位"/>
          <el-table-column prop="note" align="center" width="140" label="备注">
            <template slot-scope="scope">
              <el-input v-if="nodeId === 'Purchase1stApprove'" v-model="scope.row.note" placeholder="请输入"/>
              <span v-else>{{scope.row.note}}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="editTitle" style="margin-top:2%">
        订单附件
      </div>
      <el-upload
          v-show="nodeId === 'VendorApprove'"
          action=""
          :http-request="fileUpload"
          :file-list="reconcileOrderVO.fileList"
          :show-file-list="false"
          style="float: left; margin-right: 5px">
        <el-button :v-loading="uploadLoading" type="primary" style="margin-bottom: 5px"> 添加附件</el-button>
      </el-upload>
      <el-table border :data="reconcileOrderVO.fileList" style="margin-bottom:2%">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="accessoryName" align="left" label="附件描述" show-overflow-tooltip/>
        <el-table-column label="下载" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="download(scope.row)">下载</el-button>
            <el-button
                v-show="nodeId === 'VendorApprove'"
                type="danger"
                style="margin-left:5px"
                @click="deleteFile(scope.row,scope.$index)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId" @getNode="getNodeId"/>
    <el-dialog
        :visible.sync="dialogVisible"
        title="发票信息"
        top="5vh"
        width="500px">
      <el-form
          ref="form"
          :model="formData"
          :inline="true"
          label-width="150px">
        <div class="vm-separate">
          <el-form-item label="发票凭证的凭证号码：">
            <span>{{formData.FBELNR}}</span>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="发票凭证年度：">
            <span>{{formData.GJAHR}}</span>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="会计凭证号码：">
            <span>{{formData.KBELNR}}</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="closePage">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import constants from "@/util/constants";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "ReconcileOrderPreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        constants,
        nodeId: "",
        activeName: "first",
        isShow: true,
        balanceAmountValue: "",
        uploadLoading: false,
        dialogVisible: false,
        priceFlags: false,
        formData: {},
        priceFlagTypeList: [],
        reconcileOrderVO: {
          details: [],
          invoice: [],
        },
      };
    },
    computed: {
      //明细税额
      taxSum() {
        let sum = 0;
        this.reconcileOrderVO.details.forEach((item) => {
          sum += parseFloat((item.finalPrice * 0.13).toFixed(2));
        });
        return sum;
      },
      // 明细含税金额
      // priceTwoAndThree() {
      //   let sum = 0;
      //   this.reconcileOrderVO.details.forEach((item) => {
      //     sum += (item.finalPrice * 1.13).toFixed(6);
      //   });
      //   return sum;
      // },
      //明细不含税金额
      taxNotIncluded() {
        let sum = 0;
        this.reconcileOrderVO.details.forEach((item) => {
          sum += parseFloat(item.finalPrice);
        });
        return sum;
      },
      //结算不含税金额
      taxNotIncludedJS() {
        let sum = 0;
        this.reconcileOrderVO.details.forEach((item) => {
          sum += parseFloat((item.quantity * item.netPrice).toFixed(2));
        });
        return sum;
      },
    },
    watch: {
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `soas/${this.billId}`)
          .then(resp => {
            this.$emit("loading-status", {"loading": false});
            this.reconcileOrderVO = resp.data;
            console.log(this.reconcileOrderVO.invoice);
            this.priceFlagTypeList = resp.data.details;
          });
      },
      priceFlagType() {
        if (this.priceFlags) {
          this.priceFlagTypeList = this.priceFlagTypeList.filter((item) => item.priceFlag !== "信息");
        } else {
          this.getData();
        }
      },
      closePage() {
        this.dialogVisible = false;
        // 关闭标签
        this.$bus.$emit("closeTag", this.$route);
        this.$router.push({
          path: "/workFlow/ReconcileOrder",
        });
      },
      doApprove() {
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          approveVar: this.params.approveVar,
          billParam: "",
        };
        this.$emit("loading-status", {"loading": true});
        //节点判断&&校验必填项
        //退回到提交人时
        if (params.actionType === 2 && params.untreadedFlowId === "0;submitter") {
          this.$http.get("basic", `soas/updateStatus/${this.reconcileOrderVO.pkId}/${0}`).then((res) => {
            if (res.success) {
              this.approve(params);
            } else {
              return;
            }
          }).catch(() => {
          });
        }
        //采购确认对账单
        else if (this.params.nodeId === "Purchase1stApprove" || this.params.nodeId === "Purchase2ndApprove") {
          let result = this.reconcileOrderVO.details.some((item) => (item.quantity == null || item.quantity === "") || (item.netPrice === null || item.netPrice === "") || (item.finalPrice === null || item.finalPrice === ""));
          if (result) {
            this.$confirm("本次对账数量、不含税单价、调整差异金额(不含税)不能为空", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          let sum = this.taxNotIncluded.toFixed(2);
          let netAmount= parseFloat(this.reconcileOrderVO.invoice.netAmount).toFixed(2);
          if (sum !== netAmount && this.params.nodeId === "Purchase2ndApprove") {
            this.$confirm("余额差值不等于0CNY,请修改调整差异金额(不含税)", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          this.$http
            .post("basic", "soas/updateWithOutQty", this.reconcileOrderVO)
            .then(() => {
              this.approve(params);
            })
            .catch(() => {
              this.$emit("loading-status", {"loading": false});
            });
        }
        //供应商填写发票信息并上传发票
        else if (this.params.nodeId === "VendorApprove") {
          //校验发票信息填写
          if (!this.reconcileOrderVO.invoice.invoiceNo || !this.reconcileOrderVO.invoice.netAmount || !this.reconcileOrderVO.invoice.taxAmount || !this.reconcileOrderVO.invoice.amount || !this.reconcileOrderVO.invoice.invoiceDate) {
            this.$confirm("请完整填写发票信息", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          if (this.reconcileOrderVO.fileList.length <= 0) {
            this.$confirm("请上传发票", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          //校验发票号码
          const reg = /[0-9]/;
          if (!reg.test(this.reconcileOrderVO.invoice.invoiceNo) || (this.reconcileOrderVO.invoice.invoiceNo.length !== 8 && this.reconcileOrderVO.invoice.invoiceNo.length !== 20)) {
            this.$confirm("发票号码有误,请输入8位或20位纯数字发票号码", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          //校验发票金额
          let amount = parseFloat(this.reconcileOrderVO.invoice.netAmount) + parseFloat(this.reconcileOrderVO.invoice.taxAmount);
          amount = amount.toFixed(2);
          console.log(amount);
          console.log(this.reconcileOrderVO.invoice.amount);
          if (amount.toString() !== this.reconcileOrderVO.invoice.amount.toString()) {
            this.$confirm("发票金额填写有误！请注意未税金额保留两位小数(如88.00),请检查发票未税金额和发票税额之和是否等于发票含税金额。", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          let sum = this.taxNotIncluded.toFixed(2);
          let netAmount= parseFloat(this.reconcileOrderVO.invoice.netAmount).toFixed(2);
          if ((sum - netAmount) > 1 || (sum - netAmount) < -1 && this.params.nodeId === "VendorApprove") {
            this.$confirm("余额差值大于1CNY或者小于-1CNY,请修改调整差异金额(不含税)", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }

          this.$http.post("basic", "soas/updateWithOutQty", this.reconcileOrderVO);
          this.$http.post("basic", "soas/invoice", this.reconcileOrderVO).then((res) => {
            if (res.success) {
              this.approve(params);
            } else {
              this.$emit("loading-status", {"loading": false});
            }
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
        }
        //财务确认发票信息
        else if (this.params.nodeId === "FinanceApprove") {
          if (params.actionType === 0) {
            if (this.reconcileOrderVO.invoice.FBELNR && this.reconcileOrderVO.invoice.GJAHR && this.reconcileOrderVO.invoice.KBELNR) {
              this.$http.get("basic", `soas/updateStatus/${this.reconcileOrderVO.pkId}/${90}`).then((res) => {
                if (res.success) {
                  this.formData.FBELNR = this.reconcileOrderVO.invoice.FBELNR;
                  this.formData.GJAHR = this.reconcileOrderVO.invoice.GJAHR;
                  this.formData.KBELNR = this.reconcileOrderVO.invoice.KBELNR;
                  this.approve(params, this.formData);
                } else {
                  this.$emit("loading-status", {"loading": false});
                }
              }).catch(() => {
              });
            }else {
              this.$http.get("basic", `soas/createInvoice/${this.reconcileOrderVO.pkId}`).then((res) => {
                this.formData = res.data;
                console.log(res);
                if (res.success) {
                  this.$http.get("basic", `soas/updateStatus/${this.reconcileOrderVO.pkId}/${90}`).then((res) => {
                    if (res.success) {
                      this.approve(params, this.formData);
                    } else {
                      this.$emit("loading-status", {"loading": false});
                    }
                  }).catch(() => {
                  });
                } else {
                  this.$emit("loading-status", {"loading": false});
                  this.$confirm(res.message, "错误", {
                    type: "error",
                    showCancelButton: false,
                  });
                  return;
                }
              }).catch(() => {
              });
            }

          } else {
            this.approve(params);
          }
        } else {
          this.approve(params);
        }
      },
      //审批
      approve(params, formData) {
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            this.$message.success("操作成功");
            if (this.params.nodeId !== "FinanceApprove") {
              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/workFlow/ReconcileOrder",
              });
            } else if (formData === null) {
              this.dialogVisible = false;
            } else {
              this.dialogVisible = true;
            }
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      changeOptionalPriceVOS() {
        this.isShow = !this.isShow;
      },
      //附件上传
      fileUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        var pkid = {
          pkid: this.reconcileOrderVO.pkId,
        };
        this.$http
          .post("basic", "SoaAccessory/uploadFile", formData, pkid)
          .then((res) => {
            if (res.success) {
              this.uploadLoading = false;
              this.$message.success("上传成功");
              this.$http
                .get("basic", `soas/${this.billId}`)
                .then(resp => {
                  this.reconcileOrderVO.fileList = resp.data.fileList;
                });
            }
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },

      //附件下载
      download(row) {
        let data = {
          name: row.accessoryName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      deleteFile(row, index) {
        this.$http.delete("basic", "SoaAccessory", row.pkid).then();
        this.reconcileOrderVO.fileList.splice(index, 1);
      },

      //获取节点
      getNodeId(value) {
        this.nodeId = value.handleDetailVos[0].nodeID;
        console.log(this.nodeId);
      },

      //更新对账明细
      submitHandle() {
        this.$http
          .save("basic", "soas", this.reconcileOrderVO)
          .then(() => {
          })
          .catch(() => {
          });
      },
      //明细下载
      downloadDetail(reconcileOrderVO) {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", `soas/exportMaterial/${reconcileOrderVO.pkId}`)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .body {
    font-size: 14px;

    .table {
      width: 100%;
      border-top: 1px solid #bbb;
      border-left: 1px solid #bbb;
      margin: 2% auto;

      .tableLabel {
        width: 130px;
        padding: 10px;
        text-align: left;
        background: #f4f7fa;
        border-bottom: 1px solid #bbb;
      }

      .tableModel {
        width: 20%;
        padding: 10px;
        border-left: 1px solid #bbb;
        border-right: 1px solid #bbb;
        border-bottom: 1px solid #bbb;
      }
    }

    .table1 {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #bbb;
      border-left: 1px solid #bbb;

      .tableLabel1 {
        width: 130px;
        padding: 10px;
        text-align: left;
        background: #f4f7fa;
        border-bottom: 1px solid #bbb;
      }

      .tableModel1 {
        padding: 10px;
        border-left: 1px solid #bbb;
        border-right: 1px solid #bbb;
        border-bottom: 1px solid #bbb;
      }
    }

    .editTitle {
      font-size: 14px;
      color: #000;
      font-weight: 700;
      padding: 2px;
      border-bottom: 1px solid #333;
      margin-bottom: 2%;
    }
  }

  ::v-deep .reconcileTable .el-table__cell {
    border: 1px solid #bbb;
    border-left: none;
    border-top: none;
  }

  .reconcileTable {
    border-top: 1px solid #bbb;
  }
</style>
